import { render } from "./AudioHandler.vue?vue&type=template&id=e5b312fe&scoped=true"
import script from "./AudioHandler.vue?vue&type=script&lang=ts"
export * from "./AudioHandler.vue?vue&type=script&lang=ts"

import "./AudioHandler.vue?vue&type=style&index=0&id=e5b312fe&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-e5b312fe"

export default script